import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {EquipmentStatusesProvider} from '@providers/equipment-statuses/equipment-statuses.provider';
import {EquipmentTypesProvider} from '@providers/equipment-types/equipment-types.provider';
import {
    EquipmentCalibrationExpirationStatusProvider
} from '@providers/equipment-calibration-expiration-status/equipment-calibration-expiration-status.provider';
import {MethodsProvider} from '@providers/methods/methods.provider';
import {map} from 'rxjs/operators';
import {FiltersComponent} from '@abstract/filters.component';
import {EquipmentPagesService} from '../../../../pages/apparatus/services/equipment-pages/equipment-pages.service';
import {Observable} from 'rxjs/internal/Observable';
import {SelectValueInterface} from '@interfaces/select-value.interface';

@Component({
    selector: 'app-equipment-filters-panel',
    templateUrl: 'filters-panel.component.html',
    styleUrls: ['filters-panel.component.scss'],
})

export class FiltersPanelComponent extends FiltersComponent implements OnInit, OnDestroy {
    form = this.fb.group({
        text: [''],
        type: [''],
        method: [''],
        status: [''],
        calibration_status: [''],
    });

    public statuses$: Observable<SelectValueInterface[]>;

    /**
     * Дополнительные статусы оборудования для фильтрации к списку уже имеющихся
     */
    private statusList: any[] = [{
        id: 'allExceptDismiss',
        title: 'Все, кроме списанного'
    }, {
        id: '',
        title: 'Все оборудование'
    }];

    constructor(
        public statusListProvider: EquipmentStatusesProvider,
        public methodsProvider: MethodsProvider,
        public typesProvider: EquipmentTypesProvider,
        public calibrationStatusesProvider: EquipmentCalibrationExpirationStatusProvider,
        private fb: FormBuilder,
        service: EquipmentPagesService,
    ) {
        super(service);
    }

    ngOnInit() {
        super.ngOnInit();

        this.statuses$ = this.statusListProvider.data$.pipe(
            map(v => this.statusList.concat(v || []))
        );
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
